export default __webpack_public_path__ + "static/media/jsdelivr.23650cc4.svg";